<!-- VapiEmbed.vue -->
<template>
  <div>
    <h3 class="h4">Entrevista finalizada</h3>
    <p class="mb-3">Muito obrigado pelo seu tempo e por compartilhar suas experiências conosco. Agradecemos sua participação nesta entrevista e o interesse em fazer parte da nossa equipe.</p>
    <p class="mb-3">Entraremos em contato em breve com os próximos passos do processo seletivo.</p>
  </div>
</template>

<script>
export default {
  name: 'Intervoiceinished',
  components: {},
  props: {
  },
  data () {
    return {
    }
  },
  computed: {
  },
  created () {
  },
  watch: {
  },
  methods: {
  }
}
</script>

<style>
</style>
